import { Loader } from 'react-ui-kit-exante';

import { StyledConfirmsSkeleton } from './ConfirmsSkeleton.styled';

export const ConfirmsSkeleton = () => (
  <StyledConfirmsSkeleton>
    <Loader size="l" />
  </StyledConfirmsSkeleton>
);
